module.exports = __webpack_public_path__ + "media/images/home-celticlover-2b54547d96a88337d310d3045e084314.jpg";